export class ChangePasswordInput {
    public password: string = '';
}
